import { DataListComponent }  from './data-list/data-list.component';
import { DataGridComponent,
         DataListFilterPipe } from './data-grid/data-grid.component';
import { DataGrid2Component,
         DataList2FilterPipe,
         TransformGridPropertyPipe } from './data-grid2/data-grid2.component';

export default [
  DataListComponent,
  DataGridComponent,
  DataListFilterPipe,
  DataGrid2Component,
  DataList2FilterPipe,
  TransformGridPropertyPipe
];



// WEBPACK FOOTER //
// ./src/app/shared/data-list/index.ts